import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ServicePage from "@/pages/ServicePage";

export const Route = createFileRoute("/es/servicios/qualification-validation/")({
  head: () => buildRouteHead("/es/servicios/qualification-validation"),
  component: ServicePage,
});

